/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspostcategory_Deleted2Inputs */

const vi_cmspostcategory_deleted2 = /** @type {(inputs: Cmspostcategory_Deleted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xoá chuyên mục.`)
};

/**

* @param {Cmspostcategory_Deleted2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspostcategory_deleted2 = /** @type {((inputs?: Cmspostcategory_Deleted2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspostcategory_Deleted2Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspostcategory_deleted2(inputs)
});
export { cmspostcategory_deleted2 as "cmsPostCategory_deleted" }